import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import client from './client'

export function useMyTickets() {
  return useQuery({
    queryKey: ['support-tickets'],
    queryFn: () => client.get('/api/support').then((r) => r.data),
  })
}

export function useMyTicket(ticketId) {
  return useQuery({
    queryKey: ['support-ticket', ticketId],
    queryFn: () => client.get(`/api/support/${ticketId}`).then((r) => r.data),
    enabled: !!ticketId,
    refetchInterval: 5000,
  })
}

export function useCreateTicket() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data) => client.post('/api/support', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['support-tickets'] }),
  })
}

export function useReplyTicket(ticketId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (text) => client.post(`/api/support/${ticketId}/reply`, { text }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['support-ticket', ticketId] }),
  })
}

export function useCloseTicket(ticketId) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => client.post(`/api/support/${ticketId}/close`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['support-ticket', ticketId] })
      qc.invalidateQueries({ queryKey: ['support-tickets'] })
    },
  })
}
